import { createHighlighterCore } from 'shiki/core'
import { createWasmOnigEngine } from 'shiki/engine/oniguruma'
import hast from 'hast'

const robloxHighlightTheme = {
  name: 'roblox-studio',
  colors: {
    'editor.background': '#ffffff',
    'editor.foreground': '#000000',
  },
  settings: [
    {
      scope: 'comment',
      settings: {
        foreground: '#397f09',
      },
    },
    {
      scope: 'constant',
      settings: {
        foreground: '#007f7f',
      },
    },
    {
      scope: 'string',
      settings: {
        foreground: '#7f007f',
      },
    },
    {
      scope: ['entity', 'support'],
      settings: {
        foreground: '#0074c8',
      },
    },
    {
      scope: 'keyword',
      settings: {
        foreground: '#00007f',
      },
    },
  ],
}

export async function generateHighlightHtml(code: string) {
  const highlighter = await createHighlighterCore({
    themes: [robloxHighlightTheme],
    langs: [
      import('shiki/langs/lua.mjs'),
      // shiki will try to interop the module with the default export
      () => import('shiki/langs/css.mjs'),
    ],
    // `shiki/wasm` contains the wasm binary inlined as base64 string.
    engine: createWasmOnigEngine(import('shiki/wasm')),
  })

  const html = highlighter.codeToHtml(code, {
    lang: 'lua',
    theme: 'roblox-studio',
    transformers: [
      {
        line: (hast, line) => {
          const lineNode: hast.Element = {
            type: 'element',
            tagName: 'div',
            properties: { className: ['code-editor-line-num'] },
            children: [
              {
                type: 'text',
                value: String(line),
              },
            ],
          }
          hast.children.unshift(lineNode)
        },
      },
    ],
  })

  highlighter.dispose()
  return html
}
